import React, { useState } from 'react'
import { sidebarMenuList } from '../../utils/sidebarMenuList'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as IconMenu } from '../../assets/svg/menu-bar.svg'
import SideModal from '../molecules/SideModal'

const NavResponsive = () => {
  const [modal, setModal] = useState(false)
  const location = useLocation()

  const handleToggleModal = () => {
    setModal(!modal)
  }

  return (
    <>
      <div className="fixed bottom-0 z-20 flex w-screen items-center justify-evenly gap-6 border-t  border-solid border-slate-100 bg-white px-[40px] py-3">
        <div
          className={`flex items-center justify-center gap-2 rounded-lg text-sm hover:bg-slate-100 hover:text-black `}
          onClick={handleToggleModal}
        >
          <IconMenu /> Menu
        </div>
      </div>
      <SideModal title="Menu" isOpen={modal} toggle={handleToggleModal}>
        <div className="flex flex-col gap-4 p-4">
          {sidebarMenuList.map((e, index) => (
            <div key={index}>
              {e.childs.length > 0 ? (
                <div>
                  <div className="flex items-center gap-2 rounded-lg p-2 text-sm font-medium text-gray-700">
                    {e.icon}
                    <span>{e.title}</span>
                  </div>
                  <div className="ml-6 flex flex-col gap-2">
                    {e.childs.map((child, childIndex) => (
                      <Link
                        to={child.path}
                        key={childIndex}
                        className={`flex items-center gap-2 rounded-lg p-2 text-sm hover:bg-slate-100 hover:text-black ${
                          location.pathname === child.path && 'text-[#ACBCFF] hover:!text-black'
                        }`}
                        onClick={handleToggleModal}
                      >
                        <span className="text-lg text-gray-500">&#8658;</span>
                        <span>{child.title}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  <Link
                    to={e.path}
                    key={index}
                    className={`flex items-center gap-2 rounded-lg p-2 text-sm hover:bg-slate-100 hover:text-black ${
                      location.pathname === e.path && 'text-[#ACBCFF] hover:!text-black'
                    }`}
                    onClick={handleToggleModal}
                  >
                    {e.icon}
                    <span>{e.title}</span>
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </SideModal>
    </>
  )
}

export default NavResponsive
